'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import * as React from 'react';
import { cn } from '@crehana/compass.ui/v2';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva } from 'class-variance-authority';
import { jsx as _jsx } from "react/jsx-runtime";
var labelVariants = /*#__PURE__*/cva('tw-text-sm tw-font-medium tw-leading-none peer-disabled:tw-cursor-not-allowed peer-disabled:tw-opacity-70');

/** @deprecated Use Field of @crehana/compass.ui/v4 in a native form with React Hook Form: https://docs-frontend.creha.co/libraries/compass-ui/v4/form/ and https://docs-frontend.creha.co/libraries/compass-ui/v4/field/ */
var Label = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(LabelPrimitive.Root, _objectSpread({
    ref: ref,
    className: cn(labelVariants(), className)
  }, props));
});
Label.displayName = LabelPrimitive.Root.displayName;
export { Label };